import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import { Card, Tabs, Alert } from "antd"
import { FileTextOutlined, UserOutlined } from "@ant-design/icons"
import Breadcrumb from "../../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import EngInvoice from "./engInvoice"

const Reports = props => {
  const { t } = props
  const [errorMessage, setErrorMessage] = useState(null)

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage(null)
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [errorMessage])

  const tabItems = [
    {
      key: "1",
      label: (
        <span>
          <UserOutlined style={{ marginLeft: 8 }} />
          فاکتور مهندسین
        </span>
      ),
      children: <EngInvoice translate={t} reportType="engineer" />,
    },
    {
      key: "2",
      label: (
        <span>
          <FileTextOutlined style={{ marginLeft: 8 }} />
          فاکتور مجریان
        </span>
      ),
      children: <EngInvoice translate={t} reportType="executor" />,
    },
  ]

  return (
    <div >
      <MetaTags>
        <title>واحد گاز | گزارشات</title>
      </MetaTags>

      <div style={{ padding: "24px" }}>
        <Card
          style={{
            marginBottom: 16,
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
          bodyStyle={{ padding: "16px 24px" }}
        >
          <Breadcrumb title={t("Reports")} breadcrumbItem="گزارشات حسابداری" />
          
          {errorMessage && (
            <Alert
              message={errorMessage}
              type="error"
              closable
              showIcon
              style={{ marginTop: 16, borderRadius: 8 }}
            />
          )}
          {props.error && (
            <Alert
              message={props.error}
              type="error"
              closable
              showIcon
              style={{ marginTop: 16, borderRadius: 8 }}
            />
          )}
          {props.success && (
            <Alert
              message={props.success}
              type="success"
              closable
              showIcon
              style={{ marginTop: 16, borderRadius: 8 }}
            />
          )}
        </Card>

        <Card
          style={{
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            minHeight: "600px",
          }}
          bodyStyle={{ padding: 0 }}
        >
          <Tabs
            items={tabItems}
            defaultActiveKey="1"
            size="large"
            style={{ padding: "0 24px" }}
            tabBarStyle={{
              marginBottom: 0,
              borderBottom: "2px solid #f0f0f0",
            }}
          />
        </Card>
      </div>
    </div>
  )
}

Reports.propTypes = {
  t: PropTypes.any,
  error: PropTypes.string,
  success: PropTypes.string,
}

export default withRouter(withTranslation()(Reports))
